/**
 * @description Handle ViewMore button behaviour and show hidden refinement after click on it.
 * @param {typeof import('widgets/Widget').default} Widget Base widget for extending
 */

export default function (Widget) {
    return class ProductHero extends Widget {
        init() {
            const heroComponents = document.querySelectorAll('.b-product_hero');

            heroComponents.forEach(hero => {
                // Check content width and apply mobile class if needed
                this.handleNarrowContent(hero);
                // Initialize tiles navigation
                this.initTilesNavigation(hero);
                // Initialize accordions
                this.initAccordions(hero);
                // Initialize videos
                this.initVideos(hero);
            });
        }
        handleNarrowContent(hero) {
            const style = getComputedStyle(hero);
            const contentWidth = style.getPropertyValue('--component-width').trim();

            // Check if width is 50% or 30%
            if (contentWidth === '50%' || contentWidth === '30%') {
                hero.classList.add('b-product_hero--narrow');
            } else {
                hero.classList.remove('b-product_hero--narrow');
            }
        }
        initTilesNavigation(hero) {
            const tiles = hero.querySelectorAll('.experience-commerce_assets-productHeroTile');
            const buttonContainer = hero.querySelector('.hero-buttons');

            // Show first tile by default
            if (tiles.length > 0) {
                tiles[0].classList.add('active');
            }

            tiles.forEach((tile) => {
                const wrapper = document.createElement('li');
                const button = document.createElement('button');
                const innerTile = tile.querySelector('.b-product_hero-tile');
                button.innerText = innerTile.dataset.buttonTitle;
                button.setAttribute('data-tile-target', innerTile.dataset.buttonTitle);
                button.setAttribute('style', buttonContainer.dataset.styles);
                button.setAttribute('class', buttonContainer.dataset.classes);
                if (tile === tiles[0]) {
                    button.classList.add('active');
                }
                button.addEventListener('click', this.handleTileButtonClick.bind(this, tiles));
                wrapper.appendChild(button);
                buttonContainer.appendChild(wrapper);
            });
        }

        handleTileButtonClick(tiles, event) {
            const buttons = document.querySelectorAll('.hero-buttons button');
            const targetTitle = event.target.dataset.tileTarget;

            // Reset active states
            tiles.forEach(t => {
                t.classList.remove('active');
                // Pause any playing videos in the current tile
                const video = t.querySelector('video');
                if (video && !video.paused) {
                    video.pause();
                    // Show play button
                    const playButton = t.querySelector('.b-product_hero-video-play');
                    if (playButton) {
                        playButton.classList.remove('hidden');
                    }
                }
            });
            buttons.forEach(b => b.classList.remove('active'));

            // Set new active states
            event.target.classList.add('active');
            const targetTile = Array.from(tiles).find(t =>
                t.querySelector('.b-product_hero-tile').dataset.buttonTitle === targetTitle
            );
            if (targetTile) {
                targetTile.classList.add('active');
            }
        }

        initAccordions(hero) {
            const accordionTriggers = hero.querySelectorAll('.b-product_hero-accordion-trigger');
            accordionTriggers.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                    const content = trigger.nextElementSibling;
                    trigger.setAttribute('aria-expanded', !isExpanded);
                    content.setAttribute('aria-hidden', isExpanded);
                    // Close other accordions
                    if (!isExpanded) {
                        accordionTriggers.forEach(otherTrigger => {
                            if (otherTrigger !== trigger) {
                                otherTrigger.setAttribute('aria-expanded', 'false');
                                otherTrigger.nextElementSibling.setAttribute('aria-hidden', 'true');
                            }
                        });
                    }
                });
            });
        }

        initVideos(hero) {
            const videoWrappers = hero.querySelectorAll('.b-product_hero-video-wrapper');

            videoWrappers.forEach(wrapper => {
                const playButton = wrapper.querySelector('.b-product_hero-video-play');
                const video = wrapper.querySelector('video');
                if (video && playButton) {
                    // Store initial state
                    video.currentTime = 0;
                    playButton.classList.remove('hidden');

                    playButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (video.paused) {
                            // Pause all other videos first
                            videoWrappers.forEach(otherWrapper => {
                                const otherVideo = otherWrapper.querySelector('video');
                                const otherButton = otherWrapper.querySelector('.b-product_hero-video-play');
                                if (otherVideo && otherVideo !== video && !otherVideo.paused) {
                                    otherVideo.pause();
                                    if (otherButton) {
                                        otherButton.classList.remove('hidden');
                                    }
                                }
                            });
                            video.play();
                        } else {
                            video.pause();
                        }
                    });
                    video.addEventListener('play', () => {
                        playButton.classList.add('hidden');
                    });
                    video.addEventListener('pause', () => {
                        playButton.classList.remove('hidden');
                    });
                    video.addEventListener('ended', () => {
                        playButton.classList.remove('hidden');
                        video.currentTime = 0;
                    });
                }
            });
        }
    };
}
